module.exports = __webpack_public_path__ + "static/media/ask-question-publish.178063f1.png";